// extracted by mini-css-extract-plugin
export var avatarContainer = "_3g-1";
export var largeAvatarContainer = "_3g-2";
export var smallAvatarContainer = "_3g-0";